import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

export default function ProtectedRoute({ children, requiredRole }) {
  const { user, loading } = useAuth()
  const location = useLocation()

  console.log('ProtectedRoute Check:', {
    user,
    loading,
    requiredRole,
    currentPath: location.pathname
  })

  if (loading) {
    return <div>Laden...</div>
  }

  if (!user) {
    console.log('Kein Benutzer gefunden, leite zum Login weiter')
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (requiredRole && user.role !== requiredRole) {
    console.log(`Benutzer hat nicht die erforderliche Rolle: ${requiredRole}`)
    return <Navigate to={user.role === 'admin' ? '/admin' : '/leads'} replace />
  }

  return children
} 